import React from "react";
//import axios from "axios";
//import CodeExample from "../../partials/content/CodeExample";
//import { Table } from "react-bootstrap";
import { 
	//getPatients,
	createDigitalPlanner,
	getPatientRightsExport,
	getScreenFields,getMaster,archive,retrieve, getMenus,getSchedules,	getPatientRights,getStatus ,updateMaster,getAccounts} from "../../crud/auth.crud";
import { Link } from "react-router-dom";
import { IconButton,TextField,MenuItem,InputLabel,Select } from '@material-ui/core';

import { Bounce } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import SearchIcon from '@material-ui/icons/Search';
import DateFnsUtils from '@date-io/date-fns';
import {  format } from 'date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';	
import EditIcon from '@material-ui/icons/Edit';
import { Tooltip } from "@material-ui/core";																											

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import Icon from '@material-ui/core/Icon';
import CodeExample from "../../partials/content/CodeExample";
 import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Checkbox from '@material-ui/core/Checkbox';

import Autocomplete from '@material-ui/lab/Autocomplete';

import BulkTodo from "./CreateBulkSchedule";

import JobRequest from "./CreateJobRequest";
import CreateJobRequest from "./CreateJobRequest";





 class Patient extends React.Component {

	handleDateChange = (date) => {
    this.setState({selectedDate : date});
  };



  state = {
	pEntities:[],
	pRights:[],
	hasMoreItems:false,
	page:1,
	isLoading:false,
	isReset:false,
		filterFields :{},
	fields:[],
	filter:false,
	selectedDate:null,
	open:false,
	menu:false,
	postObj:{},
	statusFlag:false,
	statusMessage:'',
	 statusColor:'alert-success',
	 permission:[],
	 scheduleDialogOpen:false,
	 dpDialogOpen:false,

}

  contructor(props)
  {
	
  	this.setState({menu:false});
  	//console.log("patient page");
  	console.log("porpp upate:::",this.props.pRights);
	
	 
}


async componentWillReceiveProps(nextProps)
{
	let page=1;
  	 let postObj={};
	  console.log("will receive props");	
	  console.log(nextProps);
	  if(this.props.location.data!=null && this.props.location.data!= undefined)
	  	{
	  		postObj = this.props.location.data;
	  		console.log("postobje patient ",postObj);
	  		await getPatientRights(page,postObj)
	  	//.then(response => response.data)
	    .then((response) => {
	    	//console.log("patinet",response);
	      this.setState({ pRights: response.data ,postObj})
	       this.setState({totalCount:response.headers["x-total-records"]});
						      if(parseInt(response.headers["x-total-records"])>response.data.length)
						      	this.setState({hasMoreItems:true})
						      else
						      	this.setState({hasMoreItems:false})
						      this.setState({isLoading:false});
	      //console.log(this.state.users)
	     })
	  	}

	  	
		//this.forceUpdate();
}
  


  toggleMenu(){
 	//console.log("toggleMenu");
    //this.setState({ menu: true })
  }

  updateStatus(pentity)
  {
  		console.log(pentity);
  		let data ={'status':this.state.tStatus};
  		updateMaster('pentity',pentity.pEntityId,data)
  		.then((response) => {
  			console.log("update status::::",response);
  			if(response.data !='Success')
  			{
  			 this.setState({open:false,statusFlag:true,statusMessage:response.data,statusColor:'alert-danger'});
  			}
  			else
  			{
  			 this.setState({open:false,statusFlag:false,statusFlag:true,statusMessage:'Status updated successfully',statusColor:'alert-success'});
  			 this.setState({pRights: this.state.pRights.map(el => (el.id === pentity.id ? {...el, status :this.state.tStatus}: el))});	
  		
  			}

  		})
  }

  handleClose= () =>
  {
  	this.setState({open:false});
  }

  handleDpDialogClose= () =>
	{

		console.log("selected ::::",this.state.tPentity);
		let pentity = this.state.tPentity;
		let postObj = {pEntityKey:pentity.pEntityId};
		let completed=0;
		let pending=0;
	  	getPatientRights(1,postObj)
	  	.then((response) => {
	    	 pending = response.data.length;
		     this.setState({pRights: this.state.pRights.map(el => (el.id === pentity.id ? {...el,digitalPlannerStatus: response.data.digitalPlannerStatus}: el))});	
	    	

	    });


		this.setState({dpDialogOpen:false});
	}

scheduleDialogCloseNew=() =>
{
	
		console.log("selected ::::",this.state.tPentity);
		let pentity = this.state.tPentity;
		let postObj = {pEntityKey:pentity.pEntityId};
		let completed=0;
		let pending=0;
	  	getSchedules(1,postObj)
	  	.then((response) => {
	    	 pending = response.data.length;
		     this.setState({pRights: this.state.pRights.map(el => (el.id === pentity.id ? {...el, schedules :response.data.length}: el))});	
	    	 postObj = {pEntityKey:pentity.pEntityId,status:'green'};
		    getSchedules(1,postObj)
		  	.then((response) => {
		    	completed = response.data.length; 
			    this.setState({pRights: this.state.pRights.map(el => (el.id === pentity.id ? {...el, percentage :parseInt((parseInt(completed) * 100)/parseInt(pending))}: el))});	
		    })

	    });
	   
	    this.setState({scheduleDialogOpen:false});
}

scheduleDialogClose=() =>
{
	this.setState({scheduleDialogOpen:false});

	let postObj={};
	console.log(":::::props from menu::::::",this.props.match.params.id);
	console.log(":::::props from search::::::",this.props.location.data);
  	if(this.props.match.params.id!=null && this.props.match.params.id!= undefined)
  	{
		
		
		postObj["referredBusinessEntity"]=this.props.match.params.id;
	}
	if(this.props.location.data!=null && this.props.location.data!= undefined)
  	{
  		postObj = this.props.location.data;
  	}
		
		console.log("postobje patient ",postObj);

	  	getPatientRights(this.state.page,postObj)
	  	//.then(response => response.data)
	    .then((response) => {
	    	//console.log("patinet",response);
	      this.setState({ pRights: response.data })
	       this.setState({totalCount:response.headers["x-total-records"]});
						      if(parseInt(response.headers["x-total-records"])>response.data.length)
						      	this.setState({hasMoreItems:true})
						      else
						      	this.setState({hasMoreItems:false})
						      this.setState({isLoading:false});
	      //console.log(this.state.users)
	     })
}
  changeStatus(pentity)
  {

  	this.setState({open:true,tPentity:pentity,tStatus: pentity.status});
  }

  archive(pentity,flag)
  {
  	if(flag)
  	{
  		if (window.confirm("Are you sure you want to archive "+pentity.firstName + " "+pentity.lastName+"?")) 
  		{
	  	 	archive(pentity.id)
			.then((response) => {
				//
				let prights = this.state.pRights;
				let index = this.state.pRights.findIndex(el => el.id == pentity.id);
	                      
	            prights.splice(index,1);
	            this.setState({pRights:prights});
			});
		}
  	}
  	else
  	{
  		retrieve(pentity.id)
		.then((response) => {
			//
			let prights = this.state.pRights;
				let index = this.state.pRights.findIndex(el => el.id == pentity.id);
	                      
	            prights.splice(index,1);
	            this.setState({pRights:prights});
		});
  	}

  	//this.setState({open:true,tPentity:pentity,tStatus: pentity.status});
  }

  bulkTodo(pentity)
  {

  	this.setState({scheduleDialogOpen:true,tPentity:pentity,tStatus: pentity.status});
  }

  digitalPlanner(pentity)
  {

  	this.setState({dpDialogOpen:true,tPentity:pentity,tStatus: pentity.status});
  }



   handleReset(event)
  {
  		let postObj={};
  		//this.state.filter=false;
  		this.setState({isReset:true});
  		  		  		this.setState({filter:false},function(){
					this.setState({filter:true})		
  		  		})
  	 	this.state.fields[0].fields.map((field)=> {
  			
  			this.setState({[`Filter_${field.fieldName}`]:''});
			  if(field.dataType==='autocomplete')
			  {
				  this.setState({[field.fieldName]:[]});
				  
			  }
 
  			})

  			this.setState({activePage:1})
  		  	 getPatientRights(1,{})//.then(response => response.data)
			    .then((response) => {
			 		
			        this.setState({ pRights: response.data });
			        this.setState({isReset:false})
			      	if(parseInt(response.headers["x-total-records"])>this.state.pRights.length)
			      		this.setState({hasMoreItems:true})
			      	else
			      		this.setState({hasMoreItems:false})
	     });	
  }
  filterByStatus= (statusId) => {

  let postObj={};
			
  	
    console.log("filterby status:::::",statusId);
    if(statusId !=null && statusId!="")
    {
		postObj={
			status: statusId
		};
	}



    getPatientRights(1,postObj)
	  	//.then(response => response.data)
	    .then((response) => {
	    	//console.log("patinet",response);
	      this.setState({ pRights: response.data,statusFlag:true,postObj:postObj})
	       this.setState({totalCount:response.headers["x-total-records"]});
						      if(parseInt(response.headers["x-total-records"])>response.data.length)
						      	this.setState({hasMoreItems:true})
						      else
						      	this.setState({hasMoreItems:false})
						      this.setState({isLoading:false});
	      //console.log(this.state.users)
	     })
}

  loadMore(){

  	let postObj={};
    if(this.state.postObj.length==0)
    {
	  	console.log(this.state.fields[0].fields);
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='')
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					else if(field.dataType==="autocomplete")
						postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			})
	 }
	 else
	 {
	 	postObj = this.state.postObj
	 }

  	this.setState({isLoading:true,statusFlag:true})


  	this.setState({page:this.state.page+1},()=>
  	{
     getPatientRights(this.state.page,postObj)//.then(response => response.data)
  	
    .then((response) => 
    {
      this.setState({ pRights:this.state.pRights.concat(response.data) }
      ,()=>{
      	this.setState({isLoading:false})
      	if(parseInt(response.headers["x-total-records"])>this.state.pRights.length)
      	this.setState({hasMoreItems:true})
      	else
      		this.setState({hasMoreItems:false})
      	

      });
     })
	});

  }

     exportClick(event)
	{
	  	let postObj={};
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='')
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					 else if(field.dataType==="autocomplete")
					 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			}) 
	  		   
	  		    getPatientRightsExport(postObj)
					    .then((response) => {
					    	if(response.data!=""){
					    	var win = window.open(response.data, '_blank');
  							win.focus();}
  							else
  								alert('Error exporting records');

					     })
	}


    handleFilter(event)
	{
	  	let postObj={};
	  	console.log(this.state.fields[0].fields);
	  	this.setState({isLoading:true,statusFlag:true});
	  	this.state.fields[0].fields.map((field)=> {
	  			
	  			if(this.state[`Filter_${field.fieldName}`]!=undefined && this.state[`Filter_${field.fieldName}`]!='')
	  			{
	  				 if(field.dataType==="lookup")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
					else if(field.dataType==="autocomplete")
	  				 	postObj[field.lookUp.lookupKey]=this.state[`Filter_${field.fieldName}`];
	  				 else if (field.dataType==="date")
	  				 {
	  				 	//alert(field.fieldName+' : '+this.state[`Filter_${field.fieldName}`]);
	  				 	let varSelectedDate=this.state[`Filter_${field.fieldName}`]
	  				 	let formattedDate=format(varSelectedDate, 'yyyy-MM-dd')
	  				 	//const formattedDate = varSelectedDate.getFullYear()+'-'+(varSelectedDate.getMonth()+1)+'-'
	  				 	//+varSelectedDate.getDate();
	  				 	//alert(formattedDate);
	  				 	postObj[field.fieldName]=formattedDate;
	  				 }
	  				 else
	  				 {
	  				 	
	  				 	postObj[field.fieldName]=this.state[`Filter_${field.fieldName}`];
	  				 }
	  			}

	  			})
	  			this.setState({activePage:1})
	  		   
	  		    getPatientRights(1,postObj)
					    .then((response) => {
					      this.setState({ pRights: response.data,page:1,postObj:postObj })
					      this.setState({totalCount:response.headers["x-total-records"]});
					      if(parseInt(response.headers["x-total-records"])>response.data.length)
					      	this.setState({hasMoreItems:true})
					      else
					      	this.setState({hasMoreItems:false})
					      this.setState({isLoading:false});
					     })
	}
  
  
  componentDidUpdate()
  {
  	//console.log("1231223");

  }

  onChangeAutocomplete(query) {

	var postObj = {
        nameLowerCase: query.toLowerCase()
        
      };
      let patientData=[];
    
    getPatientRights(1,postObj)//.then(response => response.data)
          .then((response) => {
              response.data.map((p)=>(
                 patientData.push({
                  type:0,
                  text:p.firstName + ' ' + p.lastName,
                  url: 'patient',
                  params: {pEntityId: p.pEntityId}
                })
              ))
              this.setState({ autocomPatient:patientData });
             
       }); 
  }

  componentDidMount()
  {

  	let page=1;

  	//console.log('122222');
  	  	this.setState({hasMoreItems:false,isLoading:true});

  	  	 getStatus().then(response => response.data)
      .then((data) => {
        this.setState({ mStatus: data })
       // console.log(data);
       });

      getMenus().then(response => response.data)
    .then((data) => {
      
      if(data[0] != null && data[0].permissions !=null)
                {
                 
                  console.log(data[0].permissions);
                  let perms="";
                  data[0].permissions.map((per) =>(
                    perms = perms + "," + per
                    ))
                  console.log(perms);
                   this.setState({ permission: perms })

                }
     });


       getAccounts().then(response => response.data)
      .then((data) => {
        this.setState({ mAccounts: data })
       // console.log(data);
       });

    let postObj={};
	console.log(":::::props from menu::::::",this.props.match.params.id);
	console.log(":::::props from search::::::",this.props.location.data);
  	if(this.props.match.params.id!=null && this.props.match.params.id!= undefined)
  	{
		
		
		postObj["referredBusinessEntity"]=this.props.match.params.id;
	}
	if(this.props.location.data!=null && this.props.location.data!= undefined)
  	{
  		postObj = this.props.location.data;
  	}

  
		
		console.log("postobje patient ",postObj);

	  	getPatientRights(page,postObj)
	  	//.then(response => response.data)
	    .then((response) => {
	    	//console.log("patinet",response);
	      this.setState({ pRights: response.data, postObj:postObj })
	       this.setState({totalCount:response.headers["x-total-records"]});
						      if(parseInt(response.headers["x-total-records"])>response.data.length)
						      	this.setState({hasMoreItems:true})
						      else
						      	this.setState({hasMoreItems:false})
						      this.setState({isLoading:false});
	      //console.log(this.state.users)
	     })
	

    getScreenFields('pEntity')
  	.then((fieldResponse) => {
  		this.setState({fields:fieldResponse.data});

  		//console.log("fieldResponse",fieldResponse.data)
  		
  		let filterLength=fieldResponse.data[0].fields
  			.filter((fieldFilter) => fieldFilter.dataType==='lookup' || fieldFilter.dataType==='autocomplete').length;
  		//alert('loop length : '+filterLength );
  		if(filterLength===0) this.setState({filter:true});
  		let loopCounter =0;
  		fieldResponse.data[0].fields
  			.filter((fieldFilter) => fieldFilter.dataType==='lookup' || fieldFilter.dataType==='autocomplete')
  			.map((fieldMap)=>
  					{
  				//		alert(fieldMap.lookUp.lookupName);
  							getMaster(fieldMap.lookUp.lookupName)
							.then((filterResponse)=>
								{
									//console.log('Master :',fieldMap.fieldName);
									//alert(fieldMap.fieldName);
									this.setState({[fieldMap.fieldName]:filterResponse.data});
									loopCounter++;
									if(loopCounter===filterLength)
										this.setState({filter:true});


								})
						}
  					
  				)
    });
			


  }
  datediff=(date1,date2)=>
  {
  	var Difference_In_Time = new Date(date2).getTime() - new Date(date1).getTime(); 
  
	// To calculate the no. of days between two dates 
	var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
	return Difference_In_Days;
  }
  autocompleteOnChange=(event,newValue,fieldName,lookupKey) => {
	if(event!==null && newValue!==null)
	{
	  console.log("autocomplete change:::",event ,newValue,fieldName,lookupKey,newValue[lookupKey]);
	  this.setState({[fieldName]:newValue[lookupKey]});
	}
	
  }

  autocompleteOnInputChange=async (event,value,fieldName,lookupKey,lookupName) =>  {
	if(event!==null && value!==null && value.length>3)
	{
	  //console.log("autocomplete input change:::",event ,value,fieldName,lookupKey);
	  //this.setState({[fieldName]:newValue[lookupKey]});
	  var postObj = {
        nameLowerCase: value.toLowerCase()
        
      };
      let patientData=[];
    
    	await getPatientRights(1,postObj)
          .then((response) => {
              response.data.map((p)=>(
                 patientData.push(p)
              ))
              this.setState({ [fieldName]:patientData});
       });
	   /*await getMaster(lookupName)
		.then((filterResponse)=>
		{
			this.setState({[fieldName]:filterResponse.data});
		});*/
	}
	
  }
  
  
  changeSelect(name,option)
  {
  	//alert(name);
  	//alert(option.target.value);
  	this.setState({[name]:option.target.value});
  	//onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
  }
  render() {
  	const show = (this.state.menu) ? "show" : "" ;
	  const { classes } = this.props;
    return (
       <>
       {this.state.statusFlag && this.state.statusMessage!=null && this.state.statusMessage !=='' && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}
      {

      	 

      	<div className="row">

          <div className="col-md-12">
            <CodeExample jsCode="true" csv ="true" displayChild="false" beforeCodeTitle="My Patients" exportClick={this.exportClick.bind(this)} >
              <div className="kt-section" >
              <Grid container spacing={3}>
      		  {
      			this.state.filter &&
		    	
		    	this.state.fields.map((screen) => (
		    		screen.fields.map((field)=>{
						
							if(field.dataType==='String')
							
							return(
								<Grid item xs={12} sm={6}>
									 <TextField fullWidth name={field.fieldName} label={field.displayName}
									 onChange={e=>this.setState({[`Filter_${field.fieldName}`]:e.target.value})}
									 />
						    	</Grid>
						    )
						    else if(field.dataType==='checkbox')
							
							return(
								<Grid item xs={12} sm={6}>
						    	Show Archived <Checkbox name={field.fieldName} value={true} onChange={e=>this.setState({[`Filter_${field.fieldName}`]:(!this.state[`Filter_${field.fieldName}`]).toString()})} />
					         </Grid>
					         )						
						    else if(field.dataType==='lookup' )
						    	return(
						    <Grid item xs={12} sm={6}>
						    		 <TextField fullWidth  style={{'width':'100%'}} name={field.lookUp.lookupKey}
									 select
									 label={field.displayName}
									 value={this.state[`Filter_${field.fieldName}`]}
									 onChange={option => this.changeSelect(`Filter_${field.fieldName}`,option)}
									 
									 >
									 {
										this.state[field.fieldName].map((filter) => {
											return(
											
											<MenuItem key={filter[field.lookUp.lookupId]} 
											
											value={filter[field.lookUp.lookupId]}>

											{

												field.lookUp.lookupDisplay.split(/\s*,\s*/)
												.map((keyVal) => {
															return(<>{filter[keyVal]} </>);
													}
												)
											}</MenuItem>)
										})
									
									}
									</TextField></Grid>
						    )
							else if(field.dataType==='autocomplete')
						    	return(
						    		 <Grid item xs={12} sm={6}>
										 <Autocomplete
											id={field.lookUp.lookupKey}
											name={field.lookUp.lookupKey}
											value={this.state[`Filter_${field.fieldName}`]}
											options={this.state[field.fieldName]}
											autoComplete={true}
											clearOnBlur={true}
											getOptionLabel={(option) => option[field.lookUp.lookupDisplay]}
											onChange={(event,newValue)=>{this.autocompleteOnChange(event,newValue,`Filter_${field.fieldName}`,field.lookUp.lookupId);}}
											onInputChange={(event,value)=>{this.autocompleteOnInputChange(event,value,field.fieldName,field.lookUp.lookupId,field.lookUp.lookupName);}}						
											renderInput={(params) => <TextField {...params} label={field.displayName}/>}
										/>
						    		 </Grid>
						    )
						    else	 if(field.dataType==='date' )
							return(
								<Grid item xs={12} sm={6}>
									<MuiPickersUtilsProvider  utils={DateFnsUtils}>
		      
										        <KeyboardDatePicker
										          fullWidth
										          id="date"
										          label={field.displayName}
										          name = {field.fieldName}
										          format="yyyy-MM-dd"
										          value={this.state.selectedDate}
										          onChange={date =>this.setState({[`Filter_${field.fieldName}`]:date,selectedDate:date})}
										          KeyboardButtonProps={{
										            'aria-label': 'change date',
										          }}
										        />
										      
								    </MuiPickersUtilsProvider>
								
								</Grid>
															    
						    )
						   
						
		    			}) //{/* map  inner loop close*/}
		    		)) //{/* map loop close*/}
			}
			</Grid>
	    	</div>
		    	
		    	<div>
		    	<Button
				variant="outlined"
				color="primary"
				onClick={this.handleFilter.bind(this)}
				endIcon={<Icon>search</Icon>}
				style={{'padding':'10px','margin':'10px'}}
				>
				{
					this.state.isLoading==true&&<><Bounce /></>
				}
				{
					this.state.isLoading==false&&<>Apply Filter</>
				}</Button>
				
				<Button
				variant="outlined"
				color="primary"
				onClick={this.handleReset.bind(this)}
				endIcon={<Icon>backspace</Icon>}
				style={{'padding':'10px','margin':'10px'}}
				>
				{
					this.state.isReset==true&&<><Bounce /></>
				}
				{
					this.state.isReset==false&&<>Reset Filter</>
				}
				</Button>
 				</div>

            </CodeExample>
          	</div>
            </div>
		    }
		     {/*<div className="kt-portlet">
				<div className="kt-portlet__body">
        			<div className="row">
		                {this.state.mStatus!=null && this.state.mStatus.map((status)=>(
		                  <div className="btn-toolbar kt-margin-l-20">
		                      <div className="dropdown" id="kt_subheader_group_actions_status_change">
		                      <button onClick={()=>this.filterByStatus(status.statusId)} className="btn btn-success btn-elevate btn-pill btn-sm" style={{background: status.statusId, 'border-color':status.statusId}}>
		                        {status.statusName}
		                      </button></div>
		                  </div>
		                  ))}
		                  <div className="btn-toolbar kt-margin-l-20">
		                      <div className="dropdown" id="kt_subheader_group_actions_status_change">
		                      <button onClick={()=>this.filterByStatus(null)} className="btn btn-success btn-pill btn-sm" style={{background:'#2c3e50','border-color':'#2c3e50'}} >
		                        Show All
		                      </button></div>
		                  </div>
		            </div>
		        </div>
            </div>*/}
        {/*
			this.state.isLoading===false && this.state.pRights.length===0 &&
			<div style={{"display":"flex","align-items":"center","justify-content": "center"}}>
				<Icon fontSize="large">search</Icon>
				<h2>No matching results found</h2>
			</div>
			
		*/}
       
      			{this.state.pRights.map((pentity)=> (
      
       
			<div className="kt-portlet">
				
				<div className="kt-portlet__body">
					<div className="kt-widget kt-widget--user-profile-3">
						<div className="kt-widget__top">
												<div className="kt-widget__media kt-hidden-">
													<img src="media/users/default.jpg" alt="user"/>
												</div>
												<div className="kt-widget__pic kt-widget__pic--danger kt-font-danger kt-font-boldest kt-font-light kt-hidden">
													JM
												</div>
												<div className="kt-widget__content">
													<div className="kt-widget__head">
														<a href='#' className="kt-widget__username">
															 

															 {!pentity.isDeleted &&<Link
                    to={{pathname:"/viewpatient", search:"?id="+pentity.id+"&key="+pentity.pEntityId,query:{id:pentity.pEntityId}, data: pentity, fromPath: "/patient", postObj: this.state.postObj, page: this.state.page}} target="_blank" 
                    >
                  
                    {this.datediff(pentity.createdOn,new Date())<2 && pentity.schedules<2 && 

                    	<span className="kt-badge kt-badge--warning kt-badge--lg">New</span> 
				
					}
               	


                  {pentity.firstName} {pentity.lastName} {!pentity.isDeleted && <Link  to={{pathname:"/editpatient", data: {pEntity:pentity},postObj: this.state.postObj, page: this.state.page,fromPath:'/patient'}}>
										 
										 <Tooltip
          										title="Edit Patient" 

          									>
											<IconButton>
												<EditIcon style={{ color: '#5578eb',fontSize: 18
											}}/>   
											</IconButton>
											</Tooltip>
										
										</Link>}
										{/*
															this.state.mStatus!=null &&
															(
															this.state.mStatus.filter(sts=> sts.statusId==pentity.status).map((fsts)=>(
																<Tooltip title={fsts.statusName}>
																<button type="button" className="btn btn-danger btn-elevate btn-circle btn-icon" style={{'background-color':pentity.status,'border-color':pentity.status, 'height':'10px', 'width':'10px'}}></button>
																</Tooltip>
															))
															)
															
														*/}
										 
                </Link>} {pentity.isDeleted && pentity.firstName + " " + pentity.lastName}
															
															{/*<i className="flaticon2-correct kt-font-success"></i>*/}
														</a>
														<div className="kt-widget__action">
															{this.state.permission.includes("CREATE:TASK") && !pentity.isDeleted &&
															<Link className="btn btn-brand btn-sm btn-upper"
												                    to={{pathname:"/createschedule", data: {pEntity:[pentity]}}}
												                    >
												                  To Do
												                </Link>
												            }

														{ !pentity.isDeleted && this.state.permission.includes("CREATE:JOB") && pentity.digitalPlannerStatus ===false && 
															<button type="button" onClick={()=> this.digitalPlanner(pentity)} className="btn btn-brand btn-sm btn-upper">Digital Planning</button>
													        }
														{this.state.permission.includes("CREATE:BULKASSIGNMENT") && !pentity.isDeleted &&
														<button type="button" onClick={()=> this.bulkTodo(pentity)} className="btn btn-brand btn-sm btn-upper">To Do</button>
														}
															{/*<button type="button" onClick={()=> this.changeStatus(pentity)} className="btn btn-brand btn-sm btn-upper">Change Status</button>*/}
														{this.state.permission.includes("ARCHIVE:PATIENT") && pentity.isActive && !pentity.isDeleted &&
														<button type="button" onClick={()=> this.archive(pentity,true)} className="btn btn-brand btn-sm btn-upper">Archive</button>

														}
														{this.state.permission.includes("ARCHIVE:PATIENT") && !pentity.isActive && pentity.isDeleted &&
														<button type="button" onClick={()=> this.archive(pentity,false)} className="btn btn-brand btn-sm btn-upper">Retrieve</button>

														}
														</div>
													</div>
													<div className="kt-widget__subhead">
														<Tooltip title="Gender"><a href='#' ><i className="flaticon2-calendar-3"></i>{pentity.gender} </a></Tooltip>
														<Tooltip title="Patient Identification No"><a href='#' ><i className="flaticon2-placeholder"></i>{pentity.patientId}</a></Tooltip>
														{pentity.locationName!=null && 
														<Tooltip title="Location"><a href='#'><i className="flaticon2-placeholder"></i>{pentity.locationName}</a></Tooltip>}
														{pentity.email!=null && pentity.email!="" &&<Tooltip title="Patient Email"><a href='#' ><i className="flaticon2-new-email"></i>{pentity.email}</a></Tooltip>}
														<Tooltip title="Referred By"><a href='#' ><i className="flaticon2-calendar-3"></i>
														{
															this.state.mAccounts!=null && pentity.referredAccountKey!==null &&
															(
															this.state.mAccounts.filter(acc=> acc.accountId==pentity.referredAccountKey).map((facc)=>(	
																facc.accountName
															))
															)
															
														}
														{
															this.state.mAccounts!=null && pentity.referredAccountKey===null &&
															(
															this.state.mAccounts.filter(acc=> acc.accountId==pentity.accountKey).map((facc)=>(
																facc.accountName
															))
															)
															
														}
														</a></Tooltip>
														
													</div>
													<div className="kt-widget__info">
														{/*<div className="kt-widget__desc">
															Sample Notes
														</div>*/}
														{/*<div className="kt-widget__progress">
															<div className="kt-widget__text">
																Progress
															</div>
															<div className="progress" style={{height: '5px',width: '100%'}}>
																<div className="progress-bar kt-bg-success" role="progressbar" style={{width: pentity.percentage+'%'}} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
															</div>
															<div className="kt-widget__stats">
																{pentity.percentage}%
															</div>
														</div>
													*/}
													</div>
												</div>
						</div>
						<div className="kt-widget__bottom">
												{/*<div className="kt-widget__item">
													<div className="kt-widget__icon">
														<i className="flaticon-calendar-with-a-clock-time-tools"></i>
													</div>
													<div className="kt-widget__details">
														<span className="kt-widget__title">Schedules</span>
														<span className="kt-widget__value">5</span>
													</div>
												</div>*/}
												<div className="kt-widget__item">
													<div className="kt-widget__icon">
														<i className="flaticon-interface-3"></i>
													</div>
													<div className="kt-widget__details">
														<span className="kt-widget__title">Reports</span>
														{!pentity.isDeleted && <span className="kt-widget__value">{pentity.templates!=null ?  <Link
                    to={{pathname:"/viewpatient", data: pentity}}
                    >{pentity.templates.length }</Link> : 'None'}</span>}
								                    {pentity.isDeleted && <span className="kt-widget__value">{pentity.templates!=null ? pentity.templates.length  : 'None'}</span>}
													</div>
												</div>
												<div className="kt-widget__item">
													<div className="kt-widget__icon">
														<i className="flaticon-file"></i>
													</div>
													<div className="kt-widget__details">
														<span className="kt-widget__title">Documents</span>
														{!pentity.isDeleted && <span className="kt-widget__value"> {pentity.files!=null ? <Link
                    to={{pathname:"/viewpatient", data: pentity}}
                    >{ pentity.files.length} </Link> : 'None'}</span>}
                    									{pentity.isDeleted && <span className="kt-widget__value"> {pentity.files!=null ?  pentity.files.length : 'None'}</span>}
													</div>
												</div>
												<div className="kt-widget__item">
													<div className="kt-widget__icon">
														<i className="flaticon-file-2"></i>
													</div>
													<div className="kt-widget__details">
														<span className="kt-widget__title">To Do's</span>
														{!pentity.isDeleted && <span className="kt-widget__value">{pentity.schedules!=null ? <Link
                    to={{pathname:"/schedule", data: {pEntityKey:pentity.pEntityId}}}
                    >{ pentity.schedules}</Link> : 'None'}</span>}
                    									{pentity.isDeleted && <span className="kt-widget__value">{pentity.schedules!=null ? pentity.schedules : 'None'}</span>}
													</div>
												</div>
												<div className="kt-widget__item">
													<div className="kt-widget__icon">
														<i className="flaticon-chat-1"></i>
													</div>
													<div className="kt-widget__details">
														<span className="kt-widget__title">Messaging</span>
														<a href='#' className="kt-widget__value kt-font-brand">
														{!pentity.isDeleted &&<Link to={{pathname:"/chat", data: pentity}}>View</Link>}
														{pentity.isDeleted && " -- "}
														</a>
													</div>
												</div>
												<div className="kt-widget__item">
													<div className="kt-widget__icon">
														<i className="flaticon-network"></i>
													</div>
													<div className="kt-widget__details">
														<div className="kt-section__content kt-section__content--solid">
															<div className="kt-media-group">
																<a href='#' className="kt-media kt-media--sm kt-media--circle" data-toggle="kt-tooltip" data-skin="brand" data-placement="top" title="" data-original-title="John Myer">
																	<img src="media/users/100_1.jpg"  alt="user" />
																</a>
																<a href='#' className="kt-media kt-media--sm kt-media--circle" data-toggle="kt-tooltip" data-skin="brand" data-placement="top" title="" data-original-title="Alison Brandy">
																	<img src="media/users/100_10.jpg"  alt="user" />
																</a>
																<a href='#' className="kt-media kt-media--sm kt-media--circle" data-toggle="kt-tooltip" data-skin="brand" data-placement="top" title="" data-original-title="Selina Cranson">
																	<img src="media/users/100_11.jpg"  alt="user" />
																</a>
																<a href='#' className="kt-media kt-media--sm kt-media--circle" data-toggle="kt-tooltip" data-skin="brand" data-placement="top" title="" data-original-title="Micheal York">
																	<img src="media/users/100_3.jpg"  alt="user" />
																</a>
																<a href='#' className="kt-media kt-media--sm kt-media--circle" data-toggle="kt-tooltip" data-skin="brand" data-placement="top" title="" data-original-title="Micheal York">
																	<span>+5</span>
																</a>
															</div>
														</div>
													</div>
												</div>
						</div>
					</div>

				</div>
			</div>
	 
		))}
	
		{
			this.state.hasMoreItems &&
			<div style={{display:'flex', alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'}}>

        <Button
				variant="outlined"
				color="primary"
				onClick={this.loadMore.bind(this)}
				
				style={{'padding':'10px','margin':'10px'}}
				>
				{
					this.state.isLoading==true&&<><Bounce /></>
				}
				{
					this.state.isLoading==false&&<><SearchIcon style={{ color: '#5867dd',fontSize: 25}}/>  Load More</>
				}
				</Button>

			
		</div>
		}
					
		       	 {this.state.tPentity != null &&
		        <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title"
				fullWidth={true}
        		maxWidth={'sm'}>
		        
		       
		        <DialogTitle id="form-dialog-title">{this.state.tPentity.firstName + " " + this.state.tPentity.lastName}</DialogTitle>
		        <DialogContent>
		         
		          
		          <TextField
		                              labelId="status-label"
		                              id="status"
		                              margin="normal"
		                              name="status"
		                              value={this.state.tStatus}
		                              onChange={e => this.setState({ tStatus: e.target.value })}
		                              className="kt-width-full"
		                              label="Select Status"
		                              style={{'width':'100%'}}
		                            select>
		                              
		                              {this.state.mStatus.map((status) =>(
		                               
		                                
		                              (this.state.permission.includes("ALLOWEDSTATUS:"+status.statusId) || status.statusId === this.state.tStatus || !this.state.permission.includes("ALLOWEDSTATUS"))&&<MenuItem key={status.statusId} value={status.statusId}>{status.statusDescription}</MenuItem>
		                             
		                              ))}
		                            </TextField>
		        </DialogContent>
		      

		        <DialogActions>
		          <Button onClick={this.handleClose} color="primary">
		            Close
		          </Button>
		          
		          <Button onClick={()=>this.updateStatus(this.state.tPentity)} color="primary">
		            Update Status
		          </Button>
		          
		        </DialogActions>
		         
		      </Dialog>
		    }

			{/**digital planner */}
			{this.state.tPentity != null &&
		    <Dialog open={this.state.dpDialogOpen} onClose={this.handleDpDialogClose} aria-labelledby="form-dialog-title"
			fullWidth={true}
         fullScreen
			>
		        
		       
		        <DialogTitle id="form-dialog-title">Job Order</DialogTitle>
		        <DialogContent>
		         
		          
		        <CreateJobRequest pentity={this.state.tPentity}/>
		        </DialogContent>
		      

		        <DialogActions>
		          <Button onClick={this.handleDpDialogClose} color="primary">
		            Close
		          </Button>
		          
		          
		          
		        </DialogActions>
		         
		      </Dialog>
		  }
				
		    {this.state.tPentity != null &&
		    <Dialog open={this.state.scheduleDialogOpen} onClose={this.scheduleDialogCloseNew} aria-labelledby="form-dialog-title"
			fullWidth={true}
        maxWidth={'sm'}>
		        
		       
		        <DialogTitle id="form-dialog-title">{this.state.tPentity.firstName + " " + this.state.tPentity.lastName}</DialogTitle>
		        <DialogContent>
		         
		          
		        <BulkTodo pentity={this.state.tPentity}/>
		        </DialogContent>
		      

		        <DialogActions>
		          <Button onClick={this.scheduleDialogCloseNew} color="primary">
		            Close
		          </Button>
		          
		          
		          
		        </DialogActions>
		         
		      </Dialog>
		  }
      </>
    );
  }
}

export default (Patient);
